import {
  DiscontinuationStatus,
  DiscountGroup,
  ProductGroupBase,
  Supplier,
} from '@retail/products/types';
import { UserName } from './AssortmentPrices';

export interface ItemPriority {
  prioritised: boolean;
  validFrom: Date;
  validTo?: Date;
  addedBy?: string;
  addedByUser?: UserName;
}

export interface AssortmentItemBase {
  inAssortment?: boolean;
  mgSupplierItemId: number;
  mgItemNumber: number;
  finfoNumber?: number;
  nobbNumber?: number;
  primaryText: string;
  secondaryText?: string;
  supplier: Supplier;
  isStocked?: boolean;
  productGroup: ProductGroupBase;
  discountGroup?: DiscountGroup;
  primaryGtin?: string;
  priority: ItemPriority;
  discontinuationStatus?: DiscontinuationStatus;
  discontinuationDate?: Date;
}

export const isMainSupplierItem = (item: {
  supplier: Supplier;
  mainSupplierName?: string;
}): boolean => !!item.mainSupplierName && item.mainSupplierName === item.supplier.name;
